import Image from "next/image";
import "./style.css";
import Link from "next/link";

function ProfileCard({ imageUrl, name, position, linkedIn }) {
	return (
		<div className="profile_card">
			<Image width={200} height={200} src={imageUrl} alt="profile" />
			<div>
				<h4>{name}</h4>
				<p>{position}</p>
				<Link rel="canonical" href={linkedIn}>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width={28}
						height={25}
						viewBox="0 0 33 32"
						fill="none"
					>
						<rect
							x="0.25"
							y="0.25"
							width="32.5"
							height="31.5"
							rx="3.75"
							fill="white"
							stroke="white"
							strokeWidth="0.5"
						/>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M14.6861 12.2721H18.0287V13.9371C18.5102 12.9795 19.745 12.1191 21.5999 12.1191C25.1558 12.1191 26 14.0253 26 17.5227V24H22.4V18.3192C22.4 16.3275 21.9185 15.2043 20.6927 15.2043C18.9926 15.2043 18.2861 16.4148 18.2861 18.3183V24H14.6861V12.2721ZM8.513 23.847H12.113V12.1191H8.513V23.847ZM12.6287 8.295C12.6288 8.59675 12.569 8.89551 12.4526 9.17393C12.3363 9.45235 12.1658 9.70486 11.951 9.9168C11.5158 10.3494 10.9266 10.5915 10.313 10.59C9.70045 10.5896 9.11268 10.3481 8.6768 9.9177C8.46279 9.70504 8.29285 9.45224 8.17671 9.17379C8.06057 8.89534 8.00052 8.5967 8 8.295C8 7.6857 8.243 7.1025 8.6777 6.6723C9.1132 6.24134 9.70122 5.99973 10.3139 6C10.9277 6 11.5163 6.2421 11.951 6.6723C12.3848 7.1025 12.6287 7.6857 12.6287 8.295Z"
							fill="#415FFC"
						/>
					</svg>
				</Link>
			</div>
		</div>
	);
}

export default ProfileCard;
